import { render, staticRenderFns } from "./estoqueFracionamento.vue?vue&type=template&id=285d914d"
import script from "./estoqueFracionamento.ts?vue&type=script&lang=js&external"
export * from "./estoqueFracionamento.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\TafStore.PharmUP.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('285d914d')) {
      api.createRecord('285d914d', component.options)
    } else {
      api.reload('285d914d', component.options)
    }
    module.hot.accept("./estoqueFracionamento.vue?vue&type=template&id=285d914d", function () {
      api.rerender('285d914d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/home/fastaction/estoqueFracionamento/estoqueFracionamento.vue"
export default component.exports